import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import { Leaderboards } from './leaderboards';

render(
  <StrictMode>
    <Leaderboards />
  </StrictMode>,
  document.getElementById('leaderboard-root')
);
